const DEFAULT_ROW_DELIMETER = ';';
const DEFAULT_COLUMN_DELIMETER = ',';
const DEFAULT_QUOTE_DELIMETER = '"';

export interface EncodeOptions {
    rowDelimiter?: string;
    columnDelimiter?: string;
    quoteDelimiter?: string;
}

export function encode(
    rows: string[][],
    {
        rowDelimiter = DEFAULT_ROW_DELIMETER,
        columnDelimiter = DEFAULT_COLUMN_DELIMETER,
        quoteDelimiter = DEFAULT_QUOTE_DELIMETER,
    }: EncodeOptions = {}
): string {
    const lines: string[] = [];

    for (const cells of rows) {
        lines.push(
            cells
                .map((cell) =>
                    cell.includes(quoteDelimiter) ||
                    cell.includes(rowDelimiter) ||
                    cell.includes(columnDelimiter)
                        ? quoteDelimiter +
                          cell.replace(quoteDelimiter, quoteDelimiter + quoteDelimiter) +
                          quoteDelimiter
                        : cell
                )
                .join(columnDelimiter)
        );
    }

    return lines.join(rowDelimiter);
}
